import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SavedReports from '../components/SavedReports/SavedReports';
import LogoNav from '../components/Navigation/LogoNav';
import './ReportsPage.css';

const ReportsPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="reports-page">
        <LogoNav />
        <div className="reports-container">
          <div className="reports-header">
            <h1>My Reports</h1>
          </div>
          <div className="auth-required">
            <p>Please sign in to access your saved reports.</p>
            <button onClick={() => navigate('/')} className="btn-primary">
              Go to ZoningPal
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="reports-page">
      <LogoNav />
      <div className="reports-container">
        <div className="reports-header">
          <h1>My Reports</h1>
          <p className="reports-subtitle">
            View, download, and manage your saved zoning analysis reports
          </p>
        </div>
        
        <div className="reports-content">
          <SavedReports />
        </div>
      </div>
    </div>
  );
};

export default ReportsPage; 